import { useEffect, useState } from 'react';
import { Platform, StyleSheet } from 'react-native';

export const utilStyles = StyleSheet.create({
  flexOne: { flex: 1 },
  column: { flexDirection: 'column' },
  row: { flexDirection: 'row' },
  overflowVisible: { overflow: 'visible' },
  overflowHidden: { overflow: 'hidden' },
  absolute: { position: 'absolute' },
  height100pc: { height: '100%' },
  width100pc: { width: '100%' },
  textAlignCenter: { textAlign: 'center' },
  backgroundWhite: { backgroundColor: 'white' },
  screenCentered: { width: '100%', height: '100%', position: 'absolute' },
  alignItemsEnd: { alignItems: 'flex-end' },
  alignItemsCenter: { alignItems: 'center' },
  justifyContentCenter: { justifyContent: 'center' },
});

export const useOnHoverMousePointer = (enabled = true) => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'web') {
      document.body.style.cursor = hovered ? 'pointer' : 'auto';
    }
  }, [hovered]);

  const onIn = () => {
    enabled && setHovered(true);
  };
  const onOut = () => {
    enabled && setHovered(false);
  };

  return [onIn, onOut];
};
